import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchMe, type MeResponse } from '@client/api/me';
import { ApiError } from '@client/api/client';
import { useAuthStore } from '@client/stores/auth';

export function useSession() {
  const setAuthenticated = useAuthStore((s) => s.setAuthenticated);
  const setUnauthenticated = useAuthStore((s) => s.setUnauthenticated);

  const query = useQuery<MeResponse, Error>({
    queryKey: ['me'],
    queryFn: fetchMe,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 401) return false;
      return failureCount < 2;
    },
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (query.data) {
      setAuthenticated(query.data);
    } else if (query.error instanceof ApiError && query.error.status === 401) {
      setUnauthenticated();
    }
  }, [query.data, query.error, setAuthenticated, setUnauthenticated]);

  return query;
}
